import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find-index.js";
import { useUser } from '~/composables/_next/useUser';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useLocalization } from '~/composables/_next/useLocalization';
export var useProductWishlistStore = function useProductWishlistStore() {
  var _useNuxt2App = useNuxt2App(),
    $sentry = _useNuxt2App.$sentry;
  var _useLocalization = useLocalization(),
    country = _useLocalization.country,
    locale = _useLocalization.locale,
    currency = _useLocalization.currency;
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var _useUser = useUser(),
    isAuthenticated = _useUser.isAuthenticated;
  var productWishlist = useState('useProductWishlistStore', function () {
    return null;
  });
  function loadProductWishlist() {
    return _loadProductWishlist.apply(this, arguments);
  }
  /**
   * Adds a product to a wishlist.
   */
  function _loadProductWishlist() {
    _loadProductWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var force,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            force = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            if (!(!isAuthenticated.value || productWishlist.value && !force)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.prev = 3;
            _context.next = 6;
            return client.customer.getWishlist.query({
              country: country,
              locale: locale,
              currency: currency
            });
          case 6:
            productWishlist.value = _context.sent;
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context.t0);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 9]]);
    }));
    return _loadProductWishlist.apply(this, arguments);
  }
  function addProductToWishlist(_x) {
    return _addProductToWishlist.apply(this, arguments);
  }
  /**
   * Removes a product from a wishlist.
   */
  function _addProductToWishlist() {
    _addProductToWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(productId) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.customer.updateWishlist.mutate({
              action: 'add',
              productIds: [productId],
              locale: locale,
              currency: currency,
              country: country
            });
          case 2:
            productWishlist.value = _context2.sent;
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _addProductToWishlist.apply(this, arguments);
  }
  function removeProductFromWishlist(_x2) {
    return _removeProductFromWishlist.apply(this, arguments);
  }
  /**
   * Check if the product is in the wishlist.
   */
  function _removeProductFromWishlist() {
    _removeProductFromWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(lineItemId) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return client.customer.updateWishlist.mutate({
              action: 'remove',
              lineItemIds: [lineItemId],
              locale: locale,
              currency: currency,
              country: country
            });
          case 2:
            productWishlist.value = _context3.sent;
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _removeProductFromWishlist.apply(this, arguments);
  }
  function checkProductInWishlist(productId) {
    var _productWishlist$valu, _productWishlist$valu2, _productWishlist$valu3;
    if (!((_productWishlist$valu = productWishlist.value) !== null && _productWishlist$valu !== void 0 && _productWishlist$valu.lineItems) || ((_productWishlist$valu2 = productWishlist.value) === null || _productWishlist$valu2 === void 0 ? void 0 : (_productWishlist$valu3 = _productWishlist$valu2.lineItems) === null || _productWishlist$valu3 === void 0 ? void 0 : _productWishlist$valu3.length) === 0) {
      return false;
    }
    return productWishlist.value.lineItems.findIndex(function (lineItem) {
      return lineItem.productId === productId;
    }) > -1;
  }
  return {
    productWishlist: productWishlist,
    loadProductWishlist: loadProductWishlist,
    addProductToWishlist: addProductToWishlist,
    removeProductFromWishlist: removeProductFromWishlist,
    checkProductInWishlist: checkProductInWishlist
  };
};